import BaseManager from "./BaseManager";

export const postMessageTypes = {
    PMT_LOAD_PROGRESS: 'loadProgress',
    PMT_LOAD_COMPLETED: 'loadCompleted',
    PMT_AUDIO_TOGGLE: 'audioToggle',
    PMT_ROUND_START: 'roundStart',
    PMT_ROUND_END: 'roundEnd',
    PMT_STAKE_UPDATE: 'stakeUpdate',
    PMT_CLOSED: 'closed',
    PMT_ERROR_MESSAGE: 'errorMessage',
};

export const receiveMessageTypes = {
    RMT_UPDATE_BALANCE: 'updateBalance',
    RMT_STOP_AUTO_SPINS: 'stopAutospins',
    RMT_SET_AUDIO: 'setAudio',
    RMT_SHOW_HELP: 'showHelp',
    RMT_TOGGLE_PAYTABLE: 'togglePaytable',
};

export default class EveryMatrixManager extends BaseManager {
    constructor() {
        super()
    }

    init(adapter) {
        super.init(adapter)
        window.addEventListener('message', this._onMessage.bind(this));
    }

    loadProgress(progress) {
        this._send(postMessageTypes.PMT_LOAD_PROGRESS, progress);
    }

    loadCompleted() {
        this._send(postMessageTypes.PMT_LOAD_COMPLETED);
    }

    audioToggle(data) {
        this._send(postMessageTypes.PMT_AUDIO_TOGGLE, data);
    }

    roundStart(value = 0) {
        this._send(postMessageTypes.PMT_ROUND_START);
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        this._send(postMessageTypes.PMT_ROUND_END);
    }

    stakeUpdate(data) {
        this._send(postMessageTypes.PMT_STAKE_UPDATE, data);
    }

    betUpdate(data) {
        this._send(postMessageTypes.PMT_STAKE_UPDATE, data);
    }

    closed() {
        this._send(postMessageTypes.PMT_CLOSED);
    }

    errorMessage(data) {
        this._send(postMessageTypes.PMT_ERROR_MESSAGE, data);
    }

    _onMessage(event) {
        const message = event.data;
        const receiveTypes = Object.values(receiveMessageTypes);
        // console.log(message);
        if (receiveTypes.includes(message.name) && message.sender === 'emwindow') {
            this.adapter && this.adapter[message.name](message.data)
        }
    }

    _send(type, data) {
        // msg and params below is for
        const message = {
            msg: type, name: type, sender: 'game',
        };

        if (data != null) {
            message.data = data
            message.params = [data]
        } else {
            message.params = []
            message.data = {}
        }
        //console.log('>>> sendMessage: ', type, message, data)

        window.postMessage(message, '*');
    }
}
